import _defineProperty from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var sanitizePeriodicWaveOptions = function sanitizePeriodicWaveOptions(options) {
  var imag = options.imag,
      real = options.real;

  if (imag === undefined) {
    if (real === undefined) {
      return _objectSpread(_objectSpread({}, options), {}, {
        imag: [0, 0],
        real: [0, 0]
      });
    }

    return _objectSpread(_objectSpread({}, options), {}, {
      imag: Array.from(real, function () {
        return 0;
      }),
      real: real
    });
  }

  if (real === undefined) {
    return _objectSpread(_objectSpread({}, options), {}, {
      imag: imag,
      real: Array.from(imag, function () {
        return 0;
      })
    });
  }

  return _objectSpread(_objectSpread({}, options), {}, {
    imag: imag,
    real: real
  });
};